import { useEffect, useState } from "react";
import { MockServiciosMarketing } from "../../mocks/servicios-marketing";
import { Servicio } from "../../interfaces/servicio";
import CardServicioMarketing from "../../components/cardServicioMarketing";
import { Modal } from "react-bootstrap";
import Contacto from "../../components/contacto";

export default function MarketingServicios() {
    const [servicios, setServicios] = useState<Servicio[]>();
    const [showModal, setShowModal] = useState<boolean>();
    const [servicioNombre, setServicioNombre] = useState<string>();

    useEffect(() => {
        fetchServicios();
    }, [servicioNombre])

    const fetchServicios = async () => {
        let serviciosResponse = await MockServiciosMarketing;
        setServicios(serviciosResponse);
    }

    const openModal = (nombre: string) => {
        setServicioNombre(nombre);
        const buttonModal = document.getElementById("buttonModalContacto");
        //buttonModal?.click();
        setShowModal(true);
    }

    const closeModal = () => {
        setShowModal(false);
    }

    const renderServicios = () => servicios?.map((v, i) => <CardServicioMarketing info={v} key={i} openModal={openModal}></CardServicioMarketing>)

    return (
        <section id="servicios" className="container-fluid pt-5 h-100">
            <h3 className="text-center mb-5 fw-bold marketing__title">SERVICIOS</h3>
            <div className="marketing__servicios__container container-fluid d-flex flex-wrap justify-content-between gap-5">
                {servicios ? renderServicios() : ''}
            </div>

            <Modal show={showModal} onHide={closeModal}>
                <Modal.Header closeButton className="border-0"></Modal.Header>
                <Modal.Body>
                    {servicioNombre ? <Contacto data={`Hola. Quiero recibir más información sobre ${servicioNombre}`} isModal={true} destinatario="marketing@hargouas.com.ar"></Contacto> : ''}
                </Modal.Body>
            </Modal>
        </section>
    );
};